(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jaks-application-context"] && !Shopify.designMode) return;
  try {
    (function () {
  if (document.documentElement.dataset.jaksApplicationBound) return;
  document.documentElement.dataset.jaksApplicationBound = 'true';
  var storageKey = 'jaks.engine-browse.v1';
  var current = null;
  function publish(name, detail) {
    try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish(name, detail); } catch (_) {}
  }
  function load() {
    try {
      var candidate = JSON.parse(sessionStorage.getItem(storageKey));
      if (candidate && typeof candidate.label === 'string' && candidate.label.length <= 150 && /^\/collections\/[a-z0-9-]+$/.test(candidate.path)) current = candidate;
    } catch (_) {}
  }
  function refresh() {
    var bar = document.querySelector('[data-jaks-application]');
    if (bar) {
      bar.hidden = !current;
      bar.querySelector('[data-jaks-application-label]').textContent = current ? current.label : '';
    }
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var field = form.querySelector('[data-jaks-application-property]');
      if (!current) { if (field) field.remove(); return; }
      if (!field) {
        field = document.createElement('input'); field.type = 'hidden';
        field.name = 'properties[Application to verify]';
        field.dataset.jaksApplicationProperty = 'true'; form.appendChild(field);
      }
      field.value = current.label;
    });
    var quoteEngine = document.getElementById('rqEngine');
    if (quoteEngine && current && !quoteEngine.value) quoteEngine.value = current.label;
  }
  function save(value) {
    current = value;
    try { if (value) sessionStorage.setItem(storageKey, JSON.stringify(value)); else sessionStorage.removeItem(storageKey); } catch (_) {}
    refresh();
  }
  document.addEventListener('click', function (event) {
    var clear = event.target.closest('[data-jaks-clear-application]');
    if (clear) { save(null); publish('jaksdiesel:application_cleared', {}); return; }
    var link = event.target.closest('[data-jaks-engine-route], .mega-models a, .mnav-models a');
    if (!link) return;
    var url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/^\/collections\/[a-z0-9-]+$/.test(url.pathname)) return;
    var label = (link.dataset.jaksEngineRoute || link.textContent).replace(/\s+/g, ' ').replace(/\s*→\s*$/, '').trim();
    save({label:label.slice(0,150),path:url.pathname});
    publish('jaksdiesel:application_chosen', {collection_handle:url.pathname.split('/').pop()});
  });
  function initialize() { load(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jaks-cat-verified-references"] && !Shopify.designMode) return;
  try {
    function initVerifiedCatReferences(root) {
  root.querySelectorAll('.jd-verified-xref').forEach(function (section) {
    var input = section.querySelector('.jd-xref-search');
    if (!input || input.dataset.initialized) return;
    input.dataset.initialized = 'true';
    var rows = Array.from(section.querySelectorAll('[data-reference-numbers]'));
    var normalize = function (value) { return value.toUpperCase().replace(/[^A-Z0-9]/g, ''); };
    input.addEventListener('input', function () {
      var query = normalize(input.value);
      var shown = 0;
      rows.forEach(function (row) {
        var terms = row.getAttribute('data-reference-numbers').split(/\s+/).map(normalize);
        var match = !query || terms.some(function (term) { return term.indexOf(query) !== -1; });
        row.hidden = !match;
        if (match) shown++;
      });
      section.querySelector('[role="status"]').textContent = 'Showing ' + shown + ' verified reference ' + (shown === 1 ? 'entry.' : 'entries.');
      section.querySelector('.jd-xref-empty').hidden = shown !== 0;
    });
  });
}
initVerifiedCatReferences(document);
document.addEventListener('shopify:section:load', function (event) { initVerifiedCatReferences(event.target); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jaks-navigation-context"] && !Shopify.designMode) return;
  try {
    (() => {
  const brand = 'filter.p.m.custom.brand';
  const application = ['filter.p.m.custom.engine_make', 'filter.p.m.custom.engine_model'];
  const repairHandles = new Set(['water-pumps', 'water-pump-assemblies', 'water-pump-service-parts', 'aftercoolers']);
  const returnFilters = new Set([
    brand, ...application, 'filter.p.m.custom.part_category', 'filter.p.m.custom.part_subtype',
    'filter.p.m.custom.system', 'filter.p.m.custom.part_categories', 'filter.p.m.custom.part_subtypes',
    'filter.p.m.custom.brands', 'filter.p.m.custom.systems', 'filter.p.m.custom.engine_family', 'filter.p.m.custom.engine_generation', 'filter.p.m.custom.condition', 'filter.p.m.custom.kit_type', 'filter.p.m.custom.kit_scopes', 'filter.p.m.custom.stage_tier',
    'filter.p.product_type', 'filter.p.vendor', 'filter.p.tag', 'filter.v.availability',
    'filter.v.price.gte', 'filter.v.price.lte'
  ]);
  const sortOptions = new Set(['manual', 'most-relevant', 'best-selling', 'title-ascending', 'title-descending',
    'price-ascending', 'price-descending', 'created-ascending', 'created-descending']);
  const returnKey = 'jaks_return';
  const collectionPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([a-z0-9][a-z0-9-]*)\/?$/i;
  const productPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*\/?$/i;

  function localUrl(raw) {
    if (!raw || raw.length > 4000) return null;
    try {
      const url = new URL(raw, window.location.origin);
      return url.origin === window.location.origin && !url.username && !url.password ? url : null;
    } catch { return null; }
  }

  function resultsUrl(raw) {
    // The return token must contain a relative collection URL, never a host or redirect.
    if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return null;
    const url = localUrl(raw);
    if (!url || !collectionPath.test(url.pathname)) return null;
    const query = new URLSearchParams();
    let count = 0;
    for (const [key, value] of url.searchParams) {
      if (returnFilters.has(key) && value && value.length <= 256) query.append(key, value);
      else if (key === 'sort_by' && sortOptions.has(value)) query.set(key, value);
      else if (key === 'page' && /^[1-9]\d{0,4}$/.test(value)) query.set(key, value);
      else continue;
      if (++count > 40) return null;
    }
    const result = url.pathname + (query.size ? '?' + query.toString() : '');
    return result.length <= 3000 ? result : null;
  }

  function preserveRepairFilters(link, current) {
    const target = localUrl(link.getAttribute('href'));
    const match = target && collectionPath.exec(target.pathname);
    if (!match || !repairHandles.has(match[1])) return;
    const keys = [brand];
    // An explicit destination application replaces the whole make/model pair.
    if (!application.some(key => target.searchParams.has(key))) keys.push(...application);
    for (const key of keys) {
      if (target.searchParams.has(key)) continue;
      for (const value of current.searchParams.getAll(key)) {
        if (value && value.length <= 256) target.searchParams.append(key, value);
      }
    }
    if (target.href.length <= 4000) link.setAttribute('href', target.pathname + target.search + target.hash);
  }

  function initialize() {
    const current = localUrl(window.location.href);
    if (!current) return;
    const source = collectionPath.exec(current.pathname);
    if (source && repairHandles.has(source[1])) {
      document.querySelectorAll('[data-jaks-repair-context] a[href]').forEach(link => preserveRepairFilters(link, current));
    }
    const originalResults = resultsUrl(current.pathname + current.search);
    if (originalResults) {
      document.querySelectorAll('[data-jaks-collection-results] a[href]').forEach(link => {
        const target = localUrl(link.getAttribute('href'));
        if (!target || !productPath.test(target.pathname)) return;
        target.searchParams.set(returnKey, originalResults);
        link.setAttribute('href', target.pathname + target.search + target.hash);
      });
    }
    if (productPath.test(current.pathname) && current.searchParams.getAll(returnKey).length === 1) {
      const original = resultsUrl(current.searchParams.get(returnKey));
      if (original) document.querySelectorAll('[data-jaks-collection-return]').forEach(link => {
        link.setAttribute('href', original);
        link.textContent = link.dataset.jaksCollectionReturn;
        link.hidden = false;
        const separator = link.nextElementSibling;
        if (separator && separator.hasAttribute('data-jaks-return-separator')) separator.hidden = false;
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
